import React from 'react'
import styled from '@emotion/styled'
import { ThemeProvider as StyledThemeProvider } from 'emotion-theming'
import createTheme from './createTheme'

export const Base = styled.div`
    font-family: ${props => props.theme.font};
    line-height: ${props => props.theme.lineHeights.standard};
    font-weight: ${props => props.theme.fontWeights.medium};

    * {
        box-sizing: border-box;
    }
`

type Props = any & {
    theme?: any
    customBreakpoints?: any
}

const ThemeProvider = (props: Props) => {
    const {
        theme,
        customBreakpoints,
        ...rest
    } = props

    const mergedTheme = createTheme(theme, customBreakpoints)
    return (
        <StyledThemeProvider theme={mergedTheme}>
            <Base {...rest} />
        </StyledThemeProvider>
    )
}

export default ThemeProvider
